module.exports = __webpack_public_path__ + "img/4.d3dedb41.png";